import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {Add as AddIcon} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import GitLabProviderLogo from '../../../../components/GitLabProviderLogo'
import ProviderActions from '../../../../components/ProviderActions'
import RowInfoCopy from '../../../../components/Row/RowInfoCopy'
import useBreakpoint from '../../../../hooks/useBreakpoint'
import {Breakpoint} from '../../../../types/constEnums'
import {useDialogState} from '../../../../ui/Dialog/useDialogState'
import ProviderRowActionButton from '../../../teamDashboard/components/ProviderRow/ProviderRowActionButton'
import AddGitLabProviderDialog from './AddGitLabProviderDialog'
import GitLabProviderRow from './GitLabProviderRow'





graphql`
  fragment GitLabProviders_orgIntegrationProviders on OrgIntegrationProviders {
    gitlab {
      ...GitLabProviderRow_integrationProvider
      id
      serverBaseUrl
      clientId
    }
  }
`

const GitLabProviders = (props) => {
  const {organizationRef} = props
  const organization = useFragment(
    graphql`
      fragment GitLabProviders_organization on Organization {
        orgId: id
        viewerOrganizationUser {
          id
          role
        }
        integrationProviders {
          ...GitLabProviders_orgIntegrationProviders @relay(mask: false)
        }
      }
    `,
    organizationRef
  )
  const {orgId, viewerOrganizationUser} = organization
  const isOrgAdmin = _optionalChain([viewerOrganizationUser, 'optionalAccess', _ => _.role]) === 'ORG_ADMIN'
  const {isOpen, open, close} = useDialogState()

  const isDesktop = useBreakpoint(Breakpoint.SIDEBAR_LEFT)

  return (
    _jsxs(_Fragment, { children: [
      _jsxs('div', { className: "my-4 flex flex-col rounded-sm bg-white shadow-card"     , children: [
        _jsxs('div', { className: "flex-center flex items-center p-4"   , children: [
          _jsx(GitLabProviderLogo, {} )
          , _jsxs('div', { className: "flex flex-col px-4"  , children: [
            _jsx('div', { className: "font-semibold text-slate-700" , children: "GitLab"})
            , _jsx(RowInfoCopy, { children: "Add private servers for use by your teams."       })
          ]})
          , _jsx(ProviderActions, { children: 
            _jsx(ProviderRowActionButton, { onClick: open, disabled: !isOrgAdmin, children: 
              isDesktop ? 'Add Server' : _jsx(AddIcon, {} )
            })
          })
        ]})
        , isOrgAdmin &&
          organization.integrationProviders.gitlab.map((provider) => (
            _jsx(GitLabProviderRow, { integrationProviderRef: provider,}, provider.id )
          ))
      ]})
      , _jsx(AddGitLabProviderDialog, { orgId: orgId, isOpen: isOpen, onClose: close,} )
    ]})
  )
}

export default GitLabProviders
